import { combineReducers } from '@reduxjs/toolkit'
import { reducer as accountReducer } from '../slices/accounts'
import contactReducer from '../slices/contacts'
import smsReducer from '../slices/sms'
import analyticsReducer from '../slices/analytics'
import communicationsReducer from '../slices/communications'
import mattersReducer from '../slices/matters'
import voicemailsReducer from '../slices/voicemail'
import phoneReducer from '../slices/phone'
import addToClioReducer from '../slices/addToClio'

const rootReducer = combineReducers({
  account: accountReducer,
  contacts: contactReducer,
  sms: smsReducer,
  analytics: analyticsReducer,
  communications: communicationsReducer,
  matters: mattersReducer,
  voicemails: voicemailsReducer,
  phone: phoneReducer,
  addToClio: addToClioReducer
})

export default rootReducer
